module.exports = __webpack_public_path__ + "static/media/HowItWorks.c5993521.mp4";